import React from 'react';
import { Link, useMatch, useResolvedPath } from 'react-router-dom';

import { tabsListVariants, tabsTriggerStyles } from '@eluve/components';

const tabs = [
  { name: 'Overview', link: 'overview' },
  { name: 'Appointments', link: 'appointments' },
  { name: 'Documents', link: 'documents' },
];

const ProfileTabLink: React.FC<{ to: string; children: React.ReactNode }> = ({
  to,
  children,
}) => {
  const resolved = useResolvedPath(to);
  const isActive = useMatch({ path: resolved.pathname, end: false });

  return (
    <Link
      to={to}
      aria-current={isActive ? 'page' : undefined}
      data-state={isActive ? 'active' : 'inactive'}
      className={tabsTriggerStyles}
    >
      {children}
    </Link>
  );
};

export const ProfileTabNav: React.FC = () => {
  return (
    <nav
      aria-label="Patient profile sections"
      className="group/tabs"
      data-orientation="horizontal"
    >
      <div data-variant="default" className={tabsListVariants()}>
        {tabs.map((tab) => (
          <ProfileTabLink key={tab.link} to={tab.link}>
            {tab.name}
          </ProfileTabLink>
        ))}
      </div>
    </nav>
  );
};
